// src/Pages/Purchase/Expenses.jsx
import React, { useState, useEffect } from "react";
import { useExpenses } from "../../context/ExpensesContext";
import { Link, useNavigate } from "react-router-dom";
import "./Expenses.css";

const Expenses = () => {
  const { expenses, loading, refreshExpenses } = useExpenses();
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  // ← FIXED: Remove refreshExpenses from dependency array
  // ← Call it only once on mount
  useEffect(() => {
    refreshExpenses();
  }, []); // ← Empty array = run only on mount

  const filteredExpenses = expenses.filter(
    (exp) =>
      exp.expenseNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      exp.vendorName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      exp.customerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      exp.paidThrough?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const formatDate = (date) => {
    try {
      return new Date(date).toLocaleDateString("en-IN");
    } catch {
      return "-";
    }
  };

  const formatCurrency = (amount, currency = "INR") =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
    }).format(amount || 0);

  const handleRowClick = (id) => navigate(`/purchase/expenses/${id}`);

  return (
    <div className="expenses-wrapper">
      <div className="expenses-container">
        {/* Header */}
        <div className="expenses-header">
          <div>
            <h1>All Expenses</h1>
            <p>{expenses.length} total expenses</p>
          </div>
          <div className="header-actions">
            <input
              type="text"
              placeholder="Search by Expense#, Vendor, Customer..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Link to="/purchase/expenses/new">
              <button className="new-expense-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="12" y1="5" x2="12" y2="19" />
                  <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
                New Expense
              </button>
            </Link>
          </div>
        </div>

        {/* Loading */}
        {loading && (
          <div className="state-card">
            <p>Loading expenses...</p>
          </div>
        )}

        {/* Empty or No Results */}
        {!loading && filteredExpenses.length === 0 && (
          <div className="state-card empty">
            <h3>
              {searchTerm ? "No expenses found" : "No expenses recorded yet"}
            </h3>
            <p>
              {searchTerm
                ? `No match for "${searchTerm}"`
                : "Start tracking your business expenses"}
            </p>
            {!searchTerm && (
              <Link to="/purchase/expenses/new">
                <button className="new-expense-btn">
                  + Record First Expense
                </button>
              </Link>
            )}
          </div>
        )}

        {/* Expenses List */}
        {!loading && filteredExpenses.length > 0 && (
          <div className="expenses-list">
            {/* Desktop Header */}
            <div className="table-header3">
              <span></span>
              <span>DATE</span>
              <span>EXPENSE #</span>
              <span>VENDOR</span>
              <span>CUSTOMER</span>
              <span>ACCOUNT</span>
              <span>PAID THROUGH</span>
              <span>AMOUNT</span>
            </div>

            {/* Rows */}
            {filteredExpenses.map((exp) => (
              <div
                key={exp._id}
                className="expense-row"
                onClick={() => handleRowClick(exp._id)}
              >
                <input type="checkbox" onClick={(e) => e.stopPropagation()} />

                <span data-label="Date">{formatDate(exp.date)}</span>

                <span data-label="Expense#" className="expense-no">
                  {exp.expenseNo}
                </span>

                <span data-label="Vendor">{exp.vendorName || "-"}</span>

                <span data-label="Customer">{exp.customerName || "-"}</span>

                <span data-label="Account">
                  {exp.isItemized ? (
                    <span className="tag-itemized">Itemized</span>
                  ) : (
                    exp.items[0]?.account || "-"
                  )}
                </span>

                <span data-label="Paid Through">{exp.paidThrough || "-"}</span>

                <span data-label="Amount" className="amount">
                  {formatCurrency(exp.total, exp.currency)}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Expenses;
